"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestContextProvider = exports.useRequestContext = exports.useReqContextContext = exports.ReqContextContext = void 0;
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const noop_1 = __importDefault(require("lodash/noop"));
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const libs_language_1 = require("@hotelplan/libs.language");
const libs_utils_1 = require("@hotelplan/libs.utils");
const normalizeRequestContext_1 = __importDefault(require("./normalizeRequestContext"));
exports.ReqContextContext = react_1.default.createContext({
    reqContext: (0, normalizeRequestContext_1.default)({
        agency: undefined,
        bd4TravelUserId: undefined,
        language: libs_language_1.languageDefault,
        device: 'DESKTOP',
        partner: undefined,
        b2bMarkup: undefined,
    }),
    setReqContext: noop_1.default,
});
function useReqContextContext() {
    const ctx = react_1.default.useContext(exports.ReqContextContext);
    const updateCtx = (0, react_1.useCallback)((nextCtx) => {
        ctx.setReqContext(prevCtx => (0, normalizeRequestContext_1.default)(Object.assign(Object.assign({}, prevCtx), nextCtx)));
    }, [ctx]);
    return [ctx.reqContext, updateCtx];
}
exports.useReqContextContext = useReqContextContext;
function useRequestContext() {
    const [reqContext] = useReqContextContext();
    const { language: reqLanguage, partner, agency, bd4TravelUserId, b2bMarkup, } = reqContext;
    const [, { language }] = (0, next_i18next_1.useTranslation)();
    const { mobile } = (0, libs_context_device_type_1.useDeviceType)();
    return (0, react_1.useMemo)(() => (0, normalizeRequestContext_1.default)({
        agency,
        b2bMarkup: b2bMarkup !== null && b2bMarkup !== void 0 ? b2bMarkup : undefined,
        bd4TravelUserId,
        device: (mobile ? 'MOBILE' : 'DESKTOP'),
        language: (0, libs_utils_1.getPageLanguage)(language || reqLanguage || ''),
        partner,
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [reqContext, mobile, language]);
}
exports.useRequestContext = useRequestContext;
function RequestContextProvider(props) {
    const { initialContext, children } = props;
    const [value, setValue] = (0, react_1.useState)(initialContext);
    const ctx = (0, react_1.useMemo)(() => ({
        reqContext: value,
        setReqContext(nextValue) {
            setValue(prevCtx => {
                const nextCtx = typeof nextValue === 'function' ? nextValue(prevCtx) : nextValue;
                return (0, isEqual_1.default)(prevCtx, nextCtx) ? prevCtx : nextCtx;
            });
        },
    }), [value]);
    return (react_1.default.createElement(exports.ReqContextContext.Provider, { value: ctx }, children));
}
exports.RequestContextProvider = RequestContextProvider;
//# sourceMappingURL=RequestContext.js.map